import { fonts, gutterX, radius } from "../ticketLayout";

const styles = (theme) => ({
  container: {
    px: gutterX,
    pt: 2.5,
  },
  header: {
    display: "flex",
    alignItems: { xs: "flex-start", sm: "center" },
    justifyContent: "space-between",
    // No celular a ação desce para a linha de baixo em vez de espremer o
    // título contra ela.
    flexDirection: { xs: "column", sm: "row" },
    gap: 1,
    mb: 1.25,
  },
  titulo: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0,
  },
  tituloTexto: {
    fontSize: fonts.sectionTitle,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  acao: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    flexShrink: 0,
    alignSelf: { xs: "stretch", sm: "auto" },
    justifyContent: { xs: "flex-end", sm: "flex-start" },
  },
  cartao: {
    width: "100%",
    borderRadius: radius.panel,
    overflow: "hidden",
  },
  cartaoPadding: {
    p: { xs: 1.75, sm: 2.25 },
  },
});

export default styles;
